import React from "react";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import GridMulta from "components/Grid/GridMulta.js";
import LoadingGrid from "components/Loading/LoadingGrid.js";
import api from 'services/api.js';
import {serverApi} from 'services/constante.js';
import {msg} from 'services/msg.js';
import MySnackbarErro from 'components/Uteis/MySnackbarErro.js';
import checaLiberacaoMenu from 'services/checaLiberacaoMenu';
import MeuPlanoAtual from 'components/Uteis/MeuPlanoAtual';
import Button from 'components/CustomButtons/Button';
import GridProcessoSuspenssaoCassacao from "components/Grid/GridProcessoSuspenssaoCassacao";
 
export default class Multas extends React.Component {
  
  constructor(props) {
    super(props);
    
    checaLiberacaoMenu(props);
    
    this.state  = {
      multas: [],
      processo_suspenssao: [],
      processo_cassacao: [],
      loadingGrid: true,
      isErro: false,
      totalVeiculos: 0,
      usuarioNome: '',
      usuarioGuid: '',
      usuarioEmail: '',
    };
  } 

  componentDidMount(){
    this.carregar();
  }

  carregar = () => {
    this.setState({isErro: false});
    api.get(serverApi.url + serverApi.versao + '/Multa/Multas').then(response => {
      this.setState({
        multas: response.data.Multas,
        processo_suspenssao: response.data.ProcessoSuspensao,
        processo_cassacao: response.data.ProcessoCassacao,
      });
      
      //console.log("resposta mutas", response.data);
    })
    .catch(error => {
      console.error(error);
      this.setState({isErro: true}); 
    })
    .finally(() => {   
      this.setState({
        loadingGrid: false
      });   
    });

    //CARREGA PERFIL DO USUÁRIO PARA OBTER O GUID
    api.get(serverApi.url + serverApi.versao + '/Usuario/Perfil').then(response => {
      if(response.data !== null) {
        this.setState({
          usuarioGuid: response.data.Guid,
          usuarioNome: response.data.Nome,
          usuarioEmail: response.data.Email
        });
      }
    })
    .catch(error => {
      console.error(error);
    });

    //VERIFICA SE TEM VEÍCULOS
    this.setState({loadingGrid: true});
    var formdata = new FormData();
    let email_user = localStorage.getItem("CLLogin");
    formdata.append('function', 'get_veiculos_usuario');
    formdata.append('email', email_user);

    api.post(serverApi.urlPHP + '/usuario.php', formdata).then(response => {
      //console.log("resposta veiculos user", response.data);
      this.setState({totalVeiculos: parseInt(response.data.TotalVeiculos)});
      this.setState({usuarioNome: response.data.Usuario.Nome.split("")[0]});
    })
    .catch(error => {
      console.error(error);
      this.setState({isErro: true}); 
    })
    .finally(() => {   
      this.setState({
        loadingGrid: false
      });   
    });
  }

  clickCadastarVeiculo = () => {
    this.props.history.push({
      pathname: `veiculos/cadastrar`,
      state: { qtdVeiculos: this.state.totalVeiculos }
    });
  }

  handleClickWhatsApp = async (e) => {
    e.preventDefault();
    
    //const whatsappUrl = `https://api.whatsapp.com/send?phone=5521965540660&text=Ol%C3%A1%2C+Quero+receber+meu+parecer+t%C3%A9cnico%21%0A%0A--+${encodeURIComponent(this.state.usuarioGuid)}+--`;
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=5521965540660&text=Ol%C3%A1%2C+quero+receber+minha+an%C3%A1lise+gratuita%21%0A%0A--+${encodeURIComponent(this.state.usuarioGuid)}+--`;
    
    try {
      // Fazer a chamada antes de abrir o WhatsApp
      let data = JSON.stringify({
        "email": this.state.usuarioEmail,
        "conversion": "Pediu_Parecer",
        "name": this.state.usuarioNome
      });
      
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: serverApi.urlN8N + '/send-lead-rd-station',
        headers: { 
          'x-api-key': '136DBA15429AE6535AF879B978CB4', 
          'Content-Type': 'application/json'
        },
        data: data
      };

      await api(config).then(response => {
        //console.log("response", response);
      })
      .catch(error => {
        console.error(error);
      });
    } catch (error) {
      console.error('Erro ao enviar lead:', error);
    }
    
    // Abrir o WhatsApp após a chamada (mesmo se der erro)
    window.open(whatsappUrl, '_blank');
  }
  
  render() {
  return (
    <>
        <LoadingGrid display={this.state.loadingGrid} />
        <div style={{display: (!this.state.loadingGrid ? '' : 'none'), width: '100%'}}>
          <MeuPlanoAtual />

          {this.state.processo_suspenssao.length > 0 ? (
            <GridProcessoSuspenssaoCassacao title={"Processo Suspensão"} processos={this.state.processo_suspenssao} />
          ) : ("")}

          {this.state.processo_cassacao.length > 0 ? (
            <GridProcessoSuspenssaoCassacao title={"Processo Cassação"} processos={this.state.processo_cassacao} />
          ) : ("")}
          
          <GridContainer style={{marginTop: 20, marginBottom: 20}}>
            <GridItem xs={12} sm={12} md={12} style={{display: 'flex', justifyContent: 'center'}}>
              <a
                href="#"
                onClick={this.handleClickWhatsApp}
                style={{
                  padding: '12px 24px',
                  borderRadius: '10px',
                  background: '#25D366',
                  color: '#fff',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontSize: '16px',
                  transition: 'background-color 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.target.style.background = '#20BA5A'}
                onMouseLeave={(e) => e.target.style.background = '#25D366'}
              >
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
                  <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"></path>
                  <path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"></path>
                  <path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"></path>
                  <path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"></path>
                  <path fill="#fff" fillRule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clipRule="evenodd"></path>
                </svg>
                Receber Parecer Técnico
              </a>
            </GridItem>
          </GridContainer>
          
          {((this.state.multas.length <= 0) && (this.state.totalVeiculos <= 0)) ? (
              <GridContainer style={{textAlign: 'center'}}>
                <GridItem xs={12} sm={12} md={12}>
                  <p style={{marginTop: 30}}>Legal! Você não possui nenhuma infração.</p>
                  {/* <Button type="button" onClick={this.clickCadastarVeiculo} style={{backgroundColor: '#00acc1', margin: '50px 0'}}>Cadastrar Veículo</Button> */}
                </GridItem>
              </GridContainer>
            ) :
            (
              ((this.state.totalVeiculos > 0) && (this.state.multas.length <= 0)) ?
                <p>Parabéns {this.state.usuarioNome}, você não possui nenhuma multa no momento!!!</p>
              :
               <GridMulta rota={'multas/view/'} display={!this.state.loadingGrid} multas={this.state.multas} PROPS={this.props} />
            )}
        </div>
          <MySnackbarErro IsErro={this.state.isErro} Mensagem={msg.semConexao} />
     </>
    );
  }
}